<template>
  <div class="search-box">
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">
          <font-awesome-icon icon="search"/>
        </div>
      </div>
      <input
type="text" 
        class="form-control form-control-sm searchbox" 
        :data-tippy-content="toolTip"
        placeholder="Search"
        :value="searchTerm"
        @input="onInput(($event.target as HTMLInputElement).value)"
>
      
      <font-awesome-icon 
        v-if="searchTerm !== ''" class="clear cp" icon="times" size="lg"
        @click="onInput('')"
/>
      
      
    </div>
    
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import tippy from 'tippy.js';

interface Props {
  searchTerm?: string;
  toolTip?: string;
}

withDefaults(defineProps<Props>(), {
  searchTerm: '',
  toolTip: ''
});

const emit = defineEmits<{
  search: [searchTerm: string];
}>();

const pendingDebounce = ref<ReturnType<typeof setTimeout> | number>(0);

onMounted(() => {
  tippy('[data-tippy-content]');
});

function onInput(newSearchTerm: string) {
  clearTimeout(pendingDebounce.value);
  pendingDebounce.value = setTimeout(() => emitUpdate(newSearchTerm), 300);
}

function emitUpdate(newSearchTerm: string) {
  emit('search', newSearchTerm);
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use "@/variables.scss" as *;

.clear {
  z-index: 100;
  position: absolute;
  right: 7px;
  top: 5px;
  color: $bgColour;
}

.clear:hover {
  color: $linkColourHover;
}

.form-control::placeholder {
  color:#ccc;
  text-align: center
}

.searchbox {
  width: 200px;
}

.input-group-text {
  background-color: $bgColour;
  color: $bgColourLight;
}

</style>